import { configureStore } from "@reduxjs/toolkit";
import {setupListeners} from "@reduxjs/toolkit/query"
// import { apiSlice } from "./Api/ApiSlice.js";
import authReducer from "./slices/authSlice.js"
import productsReducer from "./slices/productSlice.js"
import cartReducer from "./slices/cartSlice.js"
import feedReducer from "./slices/feedsSlice.js"



export const store = configureStore({
    reducer:{
        auth:authReducer,
        products:productsReducer,
        cart:cartReducer,
        feeds:feedReducer
    },
   
})

setupListeners(store.dispatch)